import { useTranslation } from '@/i18n';
import { FileOption } from '@moneyforward/ap-frontend-components/dist/es/molecules/FileList/type';
import { useMemo } from 'react';

export const useFileOptions = (handleOptionChecked: FileOption['onChange']) => {
  const { t } = useTranslation();
  const options = useMemo((): FileOption[] => {
    return [
      {
        label: t('received_invoice.uploader.ai_ocr'),
        name: 'do_ai_ocr',
        tooltip: t('received_invoice.uploader.ai_ocr_tooltip'),
        onChange: handleOptionChecked,
      },
    ];
  }, [t, handleOptionChecked]);
  return options;
};

export type TFileOption = FileOption;
